import { render } from "./KeyResultActivity.vue?vue&type=template&id=6f5f9d8f"
import script from "./KeyResultActivity.vue?vue&type=script&lang=js"
export * from "./KeyResultActivity.vue?vue&type=script&lang=js"
script.render = render

export default script